/**
 * Created by Howard on 11/12/2020.
 */
(function($) {
    $('document').ready(function () {
        if ($('.woocommerce-order-pay').length === 0) {
            return; // Abandon this hook if target does not exist
        }

        let placeOrderButton = $('#place_order');
        let couponError = $('.coupon-error');

        $('.woocommerce').on('DOMSubtreeModified', 'form#order_review', function(){
            let wooError = $('form#order_review > ul.woocommerce-error');
            if (wooError.length === 0) {
                return;
            }
            let theError = wooError.detach();
            $('.checkout-notices').append(theError);
            $('button#place_order').removeAttr("disabled");
        });

        $('button#place_order').on('click', function(e) {
            $('.checkout-notices').empty();
        });

        let applyingCouponToOrder = false;
        function applyCouponToOrder(orderId, couponCode) {
            if (applyingCouponToOrder) return;
            applyingCouponToOrder = true;
            placeOrderButton.addClass('disabled');

            $.ajax({
                url: wpApiSettings.root + 'dsr/v1/order/'+orderId+'/coupon/'+couponCode+'/apply',
                type: "POST",
                data: {
                    action: 'woocommerce_add_coupon_discount',
                    post_type: 'shop_order'
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-WP-Nonce', wpApiSettings.nonce);
                },
                statusCode: {
                    400: function(j, s, e) {
                        if (typeof j.responseJSON.message !== 'undefined' && j.responseJSON.message.length > 0) {
                            couponError.html(j.responseJSON.message);
                            couponError.show();
                        }
                    },
                    500: function(j, s, e) {
                        if (typeof j.responseJSON.message !== 'undefined' && j.responseJSON.message.length > 0) {
                            couponError.html(j.responseJSON.message);
                            couponError.show();
                        }
                    }
                },
                complete: () => {
                    applyingCouponToOrder = false;
                    placeOrderButton.removeClass('disabled');
                }
            }).done(function(r) {
                // After coupon has been applied, add a store credit line item between taxes & fees and total
                let couponHtml = "<div class='cell small-12 medium-6 coupon-title' data-coupon-id='"+r.coupon_code+"'><h4>Store Credit</h4>&nbsp;<a href='#' class='woocommerce-remove-coupon' data-coupon-number='"+r.coupon_code+"'>[Remove]</a></div><div class='cell small-12 medium-6 coupon-price' data-coupon-id='"+r.coupon_code+"'>-<span class='woocommerce-Price-amount amount'><bdi><span class='woocommerce-Price-currencySymbol'>$</span>"+r.discount+"</bdi></span></div>";
                $(couponHtml).appendTo('.coupon-list-order-pay');
                $('.woocommerce-remove-coupon').click(function() {
                    let orderId = $('#order_number_for_coupons').val();
                    let couponCode = $(this).data('coupon-number');
                    removeCouponFromOrder(orderId, couponCode);
                });

                if (r.new_total === '0.00') {
                    $('li.payment-options').hide();
                    $("#checkout_deposit_full").prop("checked", true);
                } else {
                    $('li.payment-options').show();
                }

                // Update order total to display what's left after applying store credit
                let newTotal = "<span class='woocommerce-Price-currencySymbol'>$</span>"+r.new_total;
                $('span.total > .woocommerce-Price-amount > bdi').html(newTotal);

                // Update store credit with how much credit is remaining
                let newCouponAmount = "<span class='woocommerce-Price-currencySymbol'>$</span>"+r.new_coupon_amount;
                $('.store-credit-coupon').filter(function() {
                    return $(this).data('coupon-number') === r.coupon_code;
                }).find('.price > .woocommerce-Price-amount > bdi').html(newCouponAmount);
            });
        }

        let removingCouponFromOrder = false;
        function removeCouponFromOrder(orderId, couponCode) {
            if (removingCouponFromOrder) return;
            removingCouponFromOrder = true;
            placeOrderButton.addClass('disabled');

            $.ajax({
                url: wpApiSettings.root + 'dsr/v1/order/'+orderId+'/coupon/'+couponCode+'/remove',
                type: "POST",
                data: {
                    action: 'woocommerce_remove_order_coupon',
                    order_id: orderId,
                    coupon: couponCode
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-WP-Nonce', wpApiSettings.nonce);
                },
                statusCode: {
                    400: function(j, s, e) {
                        if (typeof j.responseJSON.message !== 'undefined' && j.responseJSON.message.length > 0) {
                            couponError.html(j.responseJSON.message);
                            couponError.show();
                        }
                    },
                    500: function(j, s, e) {
                        if (typeof j.responseJSON.message !== 'undefined' && j.responseJSON.message.length > 0) {
                            couponError.html(j.responseJSON.message);
                            couponError.show();
                        }
                    }
                },
                complete: () => {
                    removingCouponFromOrder = false;
                    placeOrderButton.removeClass('disabled');
                }
            }).done(function(r) {
                // Remove store credit line item from between taxes & fees after coupon has been removed
                $('div').filter(function() {
                    return $(this).data('coupon-id') === r.coupon_code;
                }).remove();

                if (r.new_total === '0.00') {
                    $('li.payment-options').hide();
                    $("#checkout_deposit_full").prop("checked", true);
                } else {
                    $('li.payment-options').show();
                }

                // Update total after store credit has been removed
                let newTotal = "<span class='woocommerce-Price-currencySymbol'>$</span>"+r.new_total;
                $('span.total > .woocommerce-Price-amount > bdi').html(newTotal);

                // Update store credit amount after amount has been restored to the coupon
                let newCouponAmount = "<span class='woocommerce-Price-currencySymbol'>$</span>"+r.new_coupon_amount;
                $('.store-credit-coupon').filter(function() {
                    return $(this).data('coupon-number') === r.coupon_code;
                }).find('.price > .woocommerce-Price-amount > bdi').html(newCouponAmount);
            });
        }

        // Handle customer applying store credit to order
        $('.store-credit-coupon:not([disabled])').click(function() {
            let orderId = $('#order_number_for_coupons').val();
            let couponCode = $(this).data('coupon-number');
            couponError.hide();
            applyCouponToOrder(orderId, couponCode);
        });

        // Handle customer removing store credit from order
        $('.woocommerce-remove-coupon').click(function() {
            let orderId = $('#order_number_for_coupons').val();
            let couponCode = $(this).data('coupon-number');
            couponError.hide();
            removeCouponFromOrder(orderId, couponCode);
        });

        function setError(contents) {
            let checkoutNotices = $('.checkout-notices');
            checkoutNotices.empty();
            checkoutNotices.append('<ul class="woocommerce-error">'+contents+'</ul>');
            $('form#order_review').unblock();
            $('button#place_order').removeAttr("disabled");
            window.scrollTo(0, 0);
        }

        $(document).on("submit", "form", function(e){
            let errors = '';

            let billing_first_name = $('#billing_first_name').val();
            if (billing_first_name.trim() === '') {
                errors += '<li>First name is required</li>'
            }

            let billing_last_name = $('#billing_last_name').val();
            if (billing_last_name.trim() === '') {
                errors +='<li>Last name is required</li>';
            }

            let billing_country = $('#billing_country').val();
            if (billing_country.trim() === '') {
                errors +='<li>Country is required</li>';
            }
            let billing_address_1 = $('#billing_address_1').val();
            if (billing_address_1.trim() === '') {
                errors +='<li>Street address is required</li>';
            }

            let billing_city = $('#billing_city').val();
            if (billing_city.trim() === '') {
                errors +='<li>Town / city is required</li>';
            }

            let billing_state = $('#billing_state').val();
            if (billing_state.trim() === '') {
                errors += '<li>State is required</li>';
            }

            let billing_postcode = $('#billing_postcode').val();
            if (billing_postcode.trim() === '') {
                errors +='<li>Zip code is required</li>';
            }

            let billing_email = $('#billing_email').val();
            if (billing_email.trim() === '') {
                errors +='<li>Email address is required</li>';
            }

            let billing_phone = $('#billing_phone').val();
            if (billing_phone.trim() === '') {
                errors +='<li>Phone is required</li>';
            }

            if (errors !== '') {
                setError(errors);
                e.preventDefault();
                return false;
            }
        });
    });
})(jQuery);
